<template>
	<div>
		<minhead :headtitle="headtitle"></minhead>
		<div class="areacontent">
			<div class="between-line">
				<div class="Centerupdown">
					<!-- <el-button type="primary" plain style="width: 100px;" @click="notReportCopyingEnterpriseButton">
                        未抄报企业
                        <i class="el-icon-office-building  el-icon--right"></i>
                    </el-button> -->
					<div class="addstyle" style="width: 110px; margin-right: 10px;" @click="notReportCopyingEnterpriseButton">
						<samp>
							未抄报企业
							<i class="el-icon-office-building  el-icon--right"></i>
						</samp>
					</div>
					<!-- <el-button type="primary" plain style="width: 100px;" @click="reportSummaryButton">
                        上报汇总
                        <i class="el-icon-document  el-icon--right"></i>
                    </el-button> -->
					<div class="addstyle" style="width: 110px; margin-right: 10px;" @click="reportSummaryButton">
						<samp>
							上报汇总
							<i class="el-icon-document  el-icon--right"></i>
						</samp>
					</div>
					<!--    <el-button type="primary" plain style="width: 100px;" @click="writeBackMonitoringButton">
                        反写监控
                        <i class="el-icon-data-line  el-icon--right"></i>
                    </el-button> -->
					<div class="addstyle" style="width: 110px; margin-right: 10px;" @click="writeBackMonitoringButton">
						<samp>
							反写监控
							<i class="el-icon-data-line  el-icon--right"></i>
						</samp>
					</div>
					<!-- <el-button type="primary" plain style="width: 100px;" @click="oneClickReportReadingButton">
                        一键抄报
                        <i class="el-icon-edit  el-icon--right"></i>
                    </el-button> -->
				</div>
				<div class="Centerupdown">
					<el-input
						style="width: 300px;margin-left: 20px;margin-right: 16px;"
						placeholder="搜索上报汇总状态,发票类型"
						prefix-icon="el-icon-search"
						v-model="likeQueryModel"
						clearable
						@input="commonQuery"
					></el-input>
				</div>
			</div>
			<div class="areatable">
				<div class="tableh">
					<el-table ref="multipleTable" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange" height="calc(100vh - 262px )">
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column fixed prop="nasrmc" label="纳税人名称" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column prop="nasrsbh" label="纳税人识别号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column prop="fplxdm" label="发票类型" align="center" min-width="100">
							<template slot-scope="scope">
								<div class="Centerhorizontally">
									<span v-if="scope.row.fplxdm === '026'">电子普票</span>
									<span v-if="scope.row.fplxdm === '028'">电子专票</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="kpjzsj" label="开票截至时间" align="left" min-width="160px" show-overflow-tooltip>
							<template slot-scope="scope">
								<div class="Centerhorizontally">{{ yyyyMMdd(scope.row.kpjzsj) }}</div>
							</template>
						</el-table-column>
						<el-table-column prop="bsqsrq" label="数据报送起始日" align="left" min-width="160px" show-overflow-tooltip>
							<template slot-scope="scope">
								<div class="Centerhorizontally">{{ yyyyMMdd(scope.row.bsqsrq) }}</div>
							</template>
						</el-table-column>
						<el-table-column prop="bszzrq" label="数据报送终止日" align="left" min-width="160px" show-overflow-tooltip>
							<template slot-scope="scope">
								<div class="Centerhorizontally">{{ yyyyMMdd(scope.row.bszzrq) }}</div>
							</template>
						</el-table-column>
						<el-table-column prop="zxbsrq" label="最终报送日" align="left" min-width="160px" show-overflow-tooltip>
							<template slot-scope="scope">
								<div class="Centerhorizontally">{{ yyyyMMdd(scope.row.zxbsrq) }}</div>
							</template>
						</el-table-column>
						<el-table-column prop="bszt" label="上报汇总状态" align="center" min-width="100">
							<template slot-scope="scope">
								<div class="Centerhorizontally">
									<span v-if="scope.row.bszt === '0'">未完成</span>
									<span v-if="scope.row.bszt === '1'">已完成</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="反写监控状态" align="center" min-width="100">
							<template slot-scope="scope">
								<div class="Centerhorizontally">
									<span v-if="scope.row.jkzt === '0'">未完成</span>
									<span v-if="scope.row.jkzt === '1'">已完成</span>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="buttompage">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[10, 20, 100, 500]"
						:page-size="pagenum"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalcount"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			/* 开具弹框 */
			page: 1,
			pagenum: 10,
			totalcount: 10,
			tableData: [],
			headtitle: ['抄报税管理', '批量抄报税'],
			likeQueryModel: '',
			selectionData: [],
			tableHeight: ''
		};
	},
	created() {
		this.initData();
		this.commonQuery();
	},
	mounted() {
		this.$nextTick(() => {
			this.tableHeight = this.diagheight();
			this.$refs.multipleTable.doLayout();
			window.onresize = () => {
				this.tableHeight = this.diagheight();
				this.$refs.multipleTable.doLayout();
			};
		});
	},
	methods: {
		handleSizeChange(val) {
			this.pagenum = val;
			this.commonQuery();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.commonQuery();
		},
		handleSelectionChange(val) {
			this.selectionData = [];
			val.forEach(item => {
				this.selectionData.push(JSON.stringify({ taxIdNumber: item.nasrsbh, invoiceType: item.fplxdm }));
			});
		},
		/* 初始化数据 */
		initData() {
			this.$https.fetchPost('/tax/copy/manage/init/data');
		},
		/* 通用查询 */
		commonQuery() {
			this.$https
				.fetchPost('/tax/copy/manage/all/copy/query', {
					likeSearch: JSON.parse(JSON.stringify(this.likeQueryModel)),
					page: this.page,
					limit: this.pagenum
				})
				.then(res => {
					this.totalcount = res.data.count;
					this.tableData = res.data.data;
				});
		},
		/* 上报汇总按钮 */
		reportSummaryButton() {
			if (!this.validateIsSelectData(this.selectionData)) return;
			this.fetchPostReportSummary(this.selectionData);
		},
		/* 反写监控按钮 */
		writeBackMonitoringButton() {
			if (!this.validateIsSelectData(this.selectionData)) return;
			this.fetchPostWriteBackMonitoring(this.selectionData);
		},
		/* 一键抄报按钮 */
		oneClickReportReadingButton() {
			if (!this.validateIsSelectData(this.selectionData)) return;
			this.fetchPostOneClickReportReading(this.selectionData);
		},
		/* 为抄报企业按钮 */
		notReportCopyingEnterpriseButton() {
			this.likeQueryModel = '未报税';
			this.commonQuery();
		},
		fetchPostReportSummary(val) {
			this.$https.fetchPost('tax/copy/manage/poll/upload', JSON.stringify(val)).then(res => {
				if (res.data.success) {
					this.commonQuery();
				}
			});
		},
		fetchPostWriteBackMonitoring(val) {
			this.$https.fetchPost('tax/copy/manage/return/monitor', JSON.stringify(val)).then(res => {
				if (res.data.success) {
					this.commonQuery();
				}
			});
		},
		fetchPostOneClickReportReading(val) {
			this.$https.fetchPost('tax/copy/manage/combination/upload/monitor', JSON.stringify(val)).then(res => {
				if (res.data.success) {
					this.commonQuery();
				}
			});
		},
		validateIsSelectData(val) {
			if (this.validateIsEmpty(val)) {
				this.$message({ type: 'warning', message: '请选择要操作的数据' });
				return false;
			}
			return true;
		},
		validateIsEmpty(val) {
			return val === undefined || val === null || val === '' || val.length < 1;
		}
	}
};
</script>

<style scoped="scoped" lang="less">
/deep/ .el-dialog__body {
	padding: 0;
}

/deep/ .el-table--small td {
	padding: 4px 0;
}

/deep/ .el-table__body-wrapper {
	min-height: 160px;
}

/deep/ .el-dialog__header {
	display: none;
}

.areatable {
	margin-top: 27px;
}

.areacontent {
	margin-left: 21px;
}
</style>
